var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relation"},[_c('iframe',{staticClass:"el-frame-iframe",attrs:{"width":_vm.windowW,"height":"100%","src":_vm.flowSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }